import { getEECSApiForRegion, getItemFromCache, setItemInCache } from 'src/utils/utils';
import * as AFTXFilterUtils from "@amzn/aftx-common/dist/utils/filter_utils";
import axios from 'axios';
import { apiFatalsMetricsPublisher } from 'src/utils/metricUtils';
import { isAftxDomain } from 'src/utils/aftx-utils';
import { getValidRegion } from 'src/utils/region-utils';
import { katalLoggerError } from "src/logger";

const AFTX_TOKEN_KEY = 'aftx-auth-token:eagle-eye';
const AFTX_USER_KEY = 'aftx-user-info:eagle-eye';


export interface AftxAuthResponse {
    authenticated: boolean;
    userAlias?: string;
    token?: string;
    error?: string;
}



//Checking if AFTXCookie is present
export const hasAftxCookie = (): boolean => {
    const cookie = document.cookie;
    return cookie !== null;
};

// AFT-X stores token in browser cookies
export const getAftxToken = (): string | null => {
    const token = document.cookie;
    return token;
};

export const getAftxUserAlias = (): string => {
    const userInfo = getItemFromCache(AFTX_USER_KEY);
    return userInfo?.userAlias || 'Guest';
};

export const getAftxCookieFromTag = (name: string): string | null => {
    const cookies = document.cookie.split(';');
    for(let cookie of cookies) {
        const [key, value] = cookie.split('=');
        if (key.trim() === name) {
            return decodeURIComponent(value);
        }
    }
    return null;
};

export const authenticateWithAftx = async (): Promise<AftxAuthResponse> => {
    const requestHeaders = {
        'Content-Type': 'application/json',
    }; 
    
    try {
        const response = await fetch(`${getEECSApiForRegion()}/authorize`, {
            method: 'POST',
            headers: requestHeaders,
            credentials: 'include' // This ensures cookies are sent with the request
        });

        const data = await response.json();
        if (response.status === 200) {
            const alias = getAftxCookieFromTag("fcmenu-employeeLogin") || 'AFTX User'
            return { authenticated: true, token: document.cookie, userAlias: alias };
        }else{
            throw new Error("Unauthenticated");
        }
        
    } catch (error) {
        if(isAftxDomain()){
            apiFatalsMetricsPublisher.publishCounterMonitor('AFTX-Auth-Failure', 1);
            const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
            katalLoggerError(
                  window.location.href,
                  "AFTX Authentication error:",
                  { error: errorMessage }
                );
            redirectToAftxAuth();
        return { authenticated: false, error: `Authentication error: ${errorMessage}` };
        }else{
            apiFatalsMetricsPublisher.publishCounterMonitor('FcMenu-Auth-Failure', 1);
            const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
             katalLoggerError(
                  window.location.href,
                  "Fc Menu Authentication error:",
                  { error: errorMessage }
                );
            redirectToFcMenuAuth();
            return { authenticated: false, error: `Authentication error: ${errorMessage}` };
        }
    }
    
};


export const redirectToAftxAuth = () => {
       const hostname = window.location.hostname;
        const extractedRegion = hostname.split('.')[1];
        switch(extractedRegion){
            case 'eu':
               window.location.replace("https://menu.eu.aftx.amazonoperations.app/")
               break;
            case 'na':
                window.location.replace("https://menu.na.aftx.amazonoperations.app/")
                break;
            case 'fe':
                window.location.replace("https://menu.fe.aftx.amazonoperations.app/")
                break;
            default:
                console.error(`Unsupported region: ${extractedRegion}`);
                alert(`This application is not supported in the ${extractedRegion} region. `);
                break;
        }
};

export const redirectToFcMenuAuth = () => {
       const hostname = window.location.hostname;
       let extractedRegion;
        const isGamma = hostname.includes('gamma');
        if(isGamma){
             extractedRegion = hostname.split('.')[2];
        }else{
             extractedRegion = hostname.split('.')[1];
        }
        switch(extractedRegion){
            case 'eu':
               window.location.replace(`https://menu.eu.aft.amazonoperations.app/`)
               break;
            case 'na':
                window.location.replace(`https://menu.na.aft.amazonoperations.app/`)
                break;
            case 'fe':
                window.location.replace(`https://menu.fe.aft.amazonoperations.app/`)
                break;
            default:
                console.error(`Unsupported region: ${extractedRegion}`);
                alert(`This application is not supported in the ${extractedRegion} region. `);
                break;
        }
};


